import { ContentfulLocation } from '@wbk/contentful/api';
import { ImageWithPlaceholder } from '@wbk/ui';
import { useTranslation } from 'react-i18next';

const Directions = ({
  locationData,
  className,
}: {
  locationData: ContentfulLocation;
  className: string;
}) => {
  const { title, address, location } = locationData;
  const { lat, lon } = location;
  const { t } = useTranslation('common');

  const mapUrl = `https://maps.google.com/maps?q=${lat},${lon}&z=15&output=embed`;
  const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lon}&travelmode=driving`;

  return (
    <div
      className={`relative w-full overflow-hidden rounded-2xl lg:h-full lg:max-h-[256px] ${className}`}
    >
      <iframe
        title={`${title} Map`}
        src={`${mapUrl}&controls=0`}
        width='100%'
        height='100%'
        style={{ position: 'absolute', top: 0, left: 0, border: 0, filter: 'invert(90%)' }}
        allowFullScreen={false}
        loading='lazy'
        referrerPolicy='no-referrer-when-downgrade'
      ></iframe>

      <div className='absolute inset-0 z-10 flex flex-col justify-between p-4 text-white'>
        <h3
          className='w-fit self-start text-start text-lg font-semibold'
          style={{
            textShadow: '5px 5px 5px #000, 5px 5px 5px #000, 5px 5px 5px #000',
          }}
        >
          {t('how_to_get_there')}
        </h3>

        <div className='flex w-full items-center justify-between'>
          <div className='max-w-[160px] text-balance text-sm'>{address}</div>

          <a
            href={directionsUrl}
            target='_blank'
            rel='noopener noreferrer'
            className='flex items-center gap-2 text-nowrap rounded-full bg-white/20 px-4 py-2 text-xs font-semibold backdrop-blur-sm transition hover:bg-white/30 sm:text-sm'
          >
            {t('get_directions')}
            <ImageWithPlaceholder
              src='/images/illustration/directions-arrow.svg'
              alt='get direction'
              className='size-fit'
            />
          </a>
        </div>
      </div>
      <div className='absolute inset-0 z-[5] bg-gradient-to-b from-black/50 via-black/20 to-black/60' />
    </div>
  );
};

export default Directions;
